// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"26dae93f","41":"1065a012","198":"aa413811","760":"a5008c33","839":"5f7b9343","900":"1cc66a4a","942":"46cf71c0","946":"83ada3ac"}[chunkId] + ".chunk.js";
};